export default class DtoDataType {
    constructor(obj = {}) {
        this.id = obj.id
        this.mnemonique = obj.mnemonique
        this.title = obj.title
        this.typeId = obj.typeid
    }
}
